import { BACKEND_URL } from "../../lib/api";
import { Button } from "../ui/button";

const resolveImg = (url) => (url && url.startsWith("/api") ? `${BACKEND_URL}${url}` : url);

export const AcquisitionsList = ({ orders, onPay, payingOrderId }) => {
  if (orders.length === 0) return null;
  return (
    <>
      <h2 className="font-serif-display text-3xl font-light mt-20 mb-6">My Acquisitions</h2>
      <div className="border border-[#E5E0D8] bg-white divide-y divide-[#E5E0D8]">
        {orders.map((o) => (
          <div
            key={o.id}
            data-testid={`order-row-${o.id}`}
            className="flex items-center justify-between gap-4 p-4"
          >
            <div className="flex items-center gap-4 min-w-0">
              {o.artwork_image && (
                <img
                  src={resolveImg(o.artwork_image)}
                  alt={o.artwork_title || "Artwork"}
                  className="w-16 h-16 object-cover border border-[#E5E0D8] flex-shrink-0"
                />
              )}
              <div className="min-w-0">
                <p className="font-serif-display text-lg text-[#111] truncate">
                  {o.artwork_title || `Artwork #${o.artwork_id.slice(0, 8)}`}
                </p>
                <p className="label-eyebrow text-[#555] mt-1">
                  {o.artist_name || ""} {o.source === "auction" && "· Won at auction"}
                </p>
              </div>
            </div>
            <div className="text-right flex flex-col items-end gap-2">
              <p className="font-mono-aam text-base text-[#1E3A8A]">${o.amount.toLocaleString()}</p>
              {o.payment_status === "paid" ? (
                <span className="label-eyebrow bg-[#1E3A8A] text-[#F4C430] px-2 py-1">Paid</span>
              ) : (
                <Button
                  onClick={() => onPay(o.id)}
                  data-testid={`pay-order-${o.id}`}
                  disabled={payingOrderId === o.id}
                  className="rounded-none bg-[#1E3A8A] hover:bg-[#162a66] text-white px-4 py-2 h-auto label-eyebrow"
                >
                  {payingOrderId === o.id ? "Redirecting…" : "Pay now"}
                </Button>
              )}
            </div>
          </div>
        ))}
      </div>
    </>
  );
};
